import React from "react";

const ButtonCard = ( props ) => {

  const handleClick = ( e ) => {
    props.onClick();
  }
  return ( <div className="mx-auto m-2 rounded-lg border-2 border-primary-300 shadow-[0_10px_24px_rgba(249,115,22,0.65)] flex flex-col justify-center items-center p-4 text-orange-500 w-28 h-28 lg:w-32 lg:h-32 xl:w-36 xl:h-36 xl:p-8 xl:m-8 xl:text-lg cursor-pointer hover:bg-green-800 hover:text-white hover:border-2 hover:border-green-800 hover:shadow-[0_10px_24px_rgba(34,197,94,0.65)] transition-all duration-200" onClick={() => handleClick()}>
    <span className="material-icons text-3xl mx-auto">{props.icon}</span>
    <p className="text-center text-sm xl:text-base">{props.text}</p>
  </div> )
}
export default ButtonCard;